import {
    MakerDataState, resetProjectSave,
    setPreviewId,
    setPreviewSaveResultFromBackend,
    setProjectSaveResultFromBackend
} from "../store/makerDataSlice";
import {AnyAction, Dispatch} from "@reduxjs/toolkit";
import ym from "react-yandex-metrika";
import {UploadStatus} from "../Interfaces/SlideData";
import {MUSIC_TYPE_LOCAL, MUSIC_TYPE_USER} from "../Interfaces/MusicData";
import axios from "axios";
import {savePreviewUrl, makerDataUrl, saveProjectUrl} from "./url";
import * as Sentry from "@sentry/react";
import {prepareData} from "./prepareData";
import getPreviewStatus, {canGetPreviewStatus} from "./getPreviewStatus";

export default async function savePreview(argsData: any) {

    let makerData = argsData.makerData;
    let dispatch = argsData.dispatch;

    if (makerData.slidesNumReady < 2 || makerData.slidesNumReady > 150) {
        return false;
    }
    await dispatch(setPreviewId(null));
    await dispatch(resetProjectSave(null));
    ym('reachGoal', 'projectSave_free');
    const data = prepareData(makerData, dispatch);

    let vkLaunchParams = {};
    if (makerData?.vkLaunchParams?.vk_app_id) {
        for (const [key, value] of Object.entries(makerData.vkLaunchParams)) {
            // @ts-ignore
            vkLaunchParams[key] = value;
        }
    }

    // Если есть previewId в GET - удаляем его из GET при сохранении нового preview
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('previewId')) {
        urlParams.delete('previewId');
        let locationWithoutPreviewId = window.location.pathname + '?' + urlParams.toString() + window.location.hash;
        window.history.replaceState({}, document.title, locationWithoutPreviewId);
    }

    const response = await axios.post(
        savePreviewUrl,
        data,
        {
            params: vkLaunchParams,
        }
    );
    if (response.data.result == 'ok' && typeof response.data.previewId !== 'undefined' && response.data.previewId !== false) {

        dispatch(setPreviewSaveResultFromBackend(response.data));
        dispatch(setPreviewId(response.data.previewId));
        if (makerData.currentTab === 'payment') {
            canGetPreviewStatus.value = true;
        }
        getPreviewStatus(response.data.previewId, dispatch, 0);

        Sentry.setTag('preview-saved', '1');
        Sentry.setTag('preview-id', response.data.previewId);
        // т.к. может быть несколько preview за одну сессию
        Sentry.setTag('preview-' + (new Date()).toISOString(), response.data.previewId);
        Sentry.addBreadcrumb({
            category: "preview",
            message: response.data.previewId,
            data: response.data.previewId,
            level: "info",
        });
    } else {
        throw ({
            message: 'Failed to save preview. Error in response.',
            response: response,
            responseConfig: JSON.stringify(response?.config),
            responseData: JSON.stringify(response?.data),
            url: savePreviewUrl
        });
    }
}